import { cva, type VariantProps } from 'class-variance-authority';
import { cn } from '../../lib/utils';

const spinnerVariants = cva('animate-spin rounded-full border-b-2', {
  variants: {
    size: {
      sm: 'h-4 w-4',
      md: 'h-8 w-8',
      lg: 'h-12 w-12',
      xl: 'h-16 w-16',
    },
    variant: {
      primary: 'border-green-600',
      muted: 'border-gray-400',
      white: 'border-white',
    },
  },
  defaultVariants: {
    size: 'md',
    variant: 'primary',
  },
});

export interface LoadingSpinnerProps
  extends Omit<React.HTMLAttributes<HTMLDivElement>, 'color'>,
    VariantProps<typeof spinnerVariants> {}

export function LoadingSpinner({ className, size, variant, ...props }: LoadingSpinnerProps) {
  return <div className={cn(spinnerVariants({ size, variant }), className)} {...props} />;
}
